import { reatomAsync, withDataAtom } from "@reatom/async";
import { ChangeConsentDto } from "definitions/poizon-sso";
import { API } from "src/api";
import { withIsLoadingAtom } from "src/common/pipes";
import { getMeRequest } from "src/store/fetchers";

export const changeConsentRequest = reatomAsync(
  async (ctx, dto: ChangeConsentDto) => {
    await API.userApi.userControllerChangeConsent(dto);

    await ctx.schedule(() => getMeRequest(ctx));
  },
  "changeConsentRequest",
).pipe(withDataAtom(null), withIsLoadingAtom());
